import React from 'react';
import { IValueBooleanRow } from './interface';
import { ValueRow } from '../ValueRow';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const ValueBooleanRow: React.FC<IValueBooleanRow> = ({
  label,
  value,
  width,
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <ValueRow label={label} width={width} verticalAlign="top">
      <Typography variant="body2">
        {value ? t('words.yes') : t('words.no')}
      </Typography>
    </ValueRow>
  );
};
